import React, { Fragment } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const borderColor = "#40A7FE";
const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    borderBottomColor: "#40A7FE",
    borderBottomWidth: 1,
    alignItems: "center",
    paddingVertical: 2,
    fontStyle: "bold",
  },
  description: {
    width: "75%",
    textAlign: "left",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingLeft: 8,
    paddingRight: 8,
    flexWrap: "wrap",
  },
  qty: {
    width: "10%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "right",
    paddingRight: 8,
  },
  rate: {
    width: "15%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "right",
    paddingRight: 8,
  },
  amount: {
    width: "15%",
    textAlign: "right",
    paddingRight: 8,
  },
});

const DetailPdfTableRow = ({ items }) => {
  const rows = items.map((item) => (
    <View style={styles.row} key={item.timeSheetDetailId.toString()}>
      <Text style={styles.qty}>{item.dayRef}</Text>
      <Text style={styles.description}>{item.dsActivity}</Text>
      <Text style={styles.rate}>{item.hoursWorked}</Text>
    </View>
  ));
  return <Fragment>{rows}</Fragment>;
};

export default DetailPdfTableRow;
